// extracted by mini-css-extract-plugin
module.exports = {"Order":"Order_Order__1217Y","LineItem":"Order_LineItem__AbAl0","PurchaserName":"Order_PurchaserName__fROnr","ItemName":"Order_ItemName__JCIp6"};